import { render, staticRenderFns } from "./DataCell.vue?vue&type=template&id=b04f015e&scoped=true&"
import script from "./DataCell.vue?vue&type=script&lang=ts&"
export * from "./DataCell.vue?vue&type=script&lang=ts&"
import style0 from "./DataCell.vue?vue&type=style&index=0&id=b04f015e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04f015e",
  null
  
)

export default component.exports